<template>
  <Fragment>
    <template v-if="$route.name !== 'productCode'">
      <router-view></router-view>
    </template>
    <section class="container" v-else>
      <Breadcrumb />
      <div class="card-wrap mt-20 mb-20">
        <section class="card-content">
          <div class="left">
            <div class="search-name mr-15">
              <span>21位组合码：</span>
              <el-input v-model="groupCode"> </el-input>
            </div>
            <div class="search-name mr-15">
              <span>21位组合码描述：</span>
              <el-input v-model="groupDesc"> </el-input>
            </div>
            <el-button type="primary" class="ml-20" @click="searchGroupCodeInfo"
              >查询</el-button
            >
          </div>
        </section>
      </div>
      <el-table :data="list" style="width: 100%" border>
        <el-table-column label="序号" width="50">
          <template slot-scope="scope">
            <span>{{ scope.$index + (pageNum - 1) * pageSize + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column label="21位组合码" width="200">
          <template slot-scope="scope">
            <span>{{ scope.row.groupCode }}</span>
          </template>
        </el-table-column>
        <el-table-column label="21位组合码描述" :fit="true">
          <template slot-scope="scope">
            <span>{{ scope.row.groupDesc }}</span>
          </template>
        </el-table-column>
        <el-table-column label="物料专用号" width="120">
          <template slot-scope="scope">
            <span>{{ scope.row.materialCode }}</span>
          </template>
        </el-table-column>
        <el-table-column label="添加时间" width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.addDate }}</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="mt-20 pagination"
        background
        layout="total,prev, pager, next, jumper"
        :total="total"
        :page-size="10"
        :current-page="pageNum"
        @prev-click="handlePrePage"
        @next-click="handleNextPage"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </section>
  </Fragment>
</template>

<script>
import { Fragment } from "vue-fragment";

import Breadcrumb from "@/components/Breadcrumb";
export default {
  name: "productCode21",
  components: {
    Breadcrumb,
    Fragment
  },
  data() {
    return {
      groupCode: "",
      groupDesc: "",
      list: [],
      pageNum: 1,
      pageSize: 10,
      total: 0
    };
  },
  methods: {
    getProductGroupCodeList() {
      let _this = this;
      let param = {
        url: "/api/productCode/getProductGroupCodeList",
        params: {
          groupCode: _this.groupCode,
          groupDesc: _this.groupDesc,
          pageNum: _this.pageNum,
          pageSize: _this.pageSize
        }
      };

      _this.$store.dispatch("getProductGroupCodeList", param).then(() => {
        _this.list = _this.$store.state.product.productGroupList.list;
        _this.total = _this.$store.state.product.productGroupList.total;
      });
    },
    //查询
    searchGroupCodeInfo() {
      let _this = this;
      _this.getProductGroupCodeList();
    },
    //当前页
    handleCurrentChange(value) {
      let _this = this;
      _this.pageNum = value;
      _this.getProductGroupCodeList();
    },
    //上一页
    handlePrePage() {
      let _this = this;
      _this.pageNum -= 1;
      _this.getProductGroupCodeList();
    },
    //下一页
    handleNextPage() {
      let _this = this;
      _this.pageNum += 1;
      _this.getProductGroupCodeList();
    }
  },
  created() {
    let _this = this;
    _this.getProductGroupCodeList();
  }
};
</script>

<style lang="sass" scoped>
.card-wrap
  .card-content
    display: flex
    align-items: center
    justify-content: space-between
    .left
      display: flex
    .el-button
      font-size: 14px
    .search-name, .search-code
      font-size: 14px
      display: flex
      align-items: center
      span
        white-space: nowrap
.pagination
  text-align: center
</style>
